import { DEFAULT_LONG_TIMEOUT_SLOW_REQUEST } from 'core/constants/constants';
import { env } from 'core/constants/env.constants';
import { UserCustomFilter } from 'core/utils/types/user-custom-filter.type';

export const getFilterByFieldValue = <T>(
    filter: UserCustomFilter<T>,
    entity: string,
    field: keyof T,
    value: unknown
): boolean => filter.entity === entity && filter.fields[field] === value;

export const handleOnClickTenantLabel = (
    ev: React.MouseEvent<HTMLElement, MouseEvent>,
    setIsVisibleTokenTooltip: React.Dispatch<React.SetStateAction<boolean>>
) => {
    const token = Object.entries(sessionStorage)
        .filter(([key]) => key.startsWith('oidc.user'))
        .map(([, value]) => JSON.parse(value))
        .map((jsonToken) => jsonToken.access_token)[0];
    if (ev.ctrlKey) {
        setIsVisibleTokenTooltip(true);
        navigator.clipboard.writeText(token);
        setTimeout(() => {
            setIsVisibleTokenTooltip(false);
        }, DEFAULT_LONG_TIMEOUT_SLOW_REQUEST);
    }
    if (ev.altKey) {
        window.open(`${env.VITE_REST_API_HOST}/aom/graphiql?path=/aom/graphql&token=${token}`, '_blank');
    }
};
